export interface StorageUnitLike {
  id: string;
  check_frequency_hours: number | null;
  active?: boolean | null;
}

export interface TempReadingLike {
  payload: { storage_unit_id: string };
  client_ts: string;
}

export const CLEANING_FREQ_HOURS: Record<string, number> = {
  giornaliera: 24,
  settimanale: 168,
  mensile: 720,
  trimestrale: 2160,
  semestrale: 4320,
  annuale: 8760,
  a_chiamata: Number.POSITIVE_INFINITY,
};

export function computeOverdueUnits(
  units: StorageUnitLike[],
  readings: TempReadingLike[],
  now: number = Date.now(),
): number {
  const last = new Map<string, number>();
  for (const r of readings) {
    const ts = Date.parse(r.client_ts);
    const cur = last.get(r.payload.storage_unit_id);
    if (cur === undefined || ts > cur) last.set(r.payload.storage_unit_id, ts);
  }
  let overdue = 0;
  for (const u of units) {
    if (u.active === false) continue;
    const freq = u.check_frequency_hours ?? 24;
    const lastTs = last.get(u.id);
    if (lastTs === undefined) {
      overdue++;
      continue;
    }
    const ageHours = (now - lastTs) / 3_600_000;
    if (ageHours > freq) overdue++;
  }
  return overdue;
}

export type CleaningBucket = 'oggi' | 'ieri' | null;

export interface CleaningScheduleLike {
  id: string;
  frequency: string;
}

export function classifyCleaning(
  s: CleaningScheduleLike,
  lastDoneMs: number | undefined,
  now: number = Date.now(),
): CleaningBucket {
  const freq = CLEANING_FREQ_HOURS[s.frequency] ?? 24;
  if (!isFinite(freq)) return null;
  const ageHours = lastDoneMs ? (now - lastDoneMs) / 3_600_000 : Number.POSITIVE_INFINITY;
  if (ageHours < freq) return null;
  if (ageHours > freq + 24) return 'ieri';
  return 'oggi';
}
